import { z } from 'zod';

export const BlockPayloadMetaSourceSchema = z.enum(['llm', 'sanitized', 'factory']);

export const BlockPayloadMetaSchema = z.object({
  source: BlockPayloadMetaSourceSchema,
});

export type BlockPayloadMetaSource = z.infer<typeof BlockPayloadMetaSourceSchema>;
export type BlockPayloadMeta = z.infer<typeof BlockPayloadMetaSchema>;

/** Campo opcional `_meta` en payloads de bloque (trazabilidad LLM vs servidor). */
export const PayloadMetaFieldSchema = z.object({
  _meta: BlockPayloadMetaSchema.optional(),
});

export function withPayloadMeta<T extends Record<string, unknown>>(
  payload: T,
  source: BlockPayloadMetaSource,
): T & { _meta: BlockPayloadMeta } {
  return {
    ...payload,
    _meta: { source },
  };
}
